// src/Register/Register.js

import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'

import Layout from 'components/Layout'
import DefendantRegister from 'components/DefendantRegister'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

const Register = observer(class Register extends Component {

  stores = {
    defendantStore: this.props.defendantStore,
    bondsmanStore: this.props.bondsmanStore,
    userStore: this.props.userStore
  }


  render() {
    return (
      <Layout bodyClassName="layout--register">
        <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_SITE_RECAPTCHA_KEY}>
          <DefendantRegister {...this.props} />
        </GoogleReCaptchaProvider>
      </Layout>
    )
  }
})

export default inject('userStore','bondsmanStore','defendantStore')(Register)